import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle, Button } from "@mui/material";

interface BankAccountBannerProps {
  /** Nudge copy; when null/empty the banner renders nothing. */
  message: string | null;
  onAdd: () => void;
  actionLabel?: string;
}

/**
 * Non-blocking nudge shown when the payee has no personal bank account;
 * submitting is still allowed.
 */
const BankAccountBanner: React.FC<BankAccountBannerProps> = ({
  message,
  onAdd,
  actionLabel,
}) => {
  const { t } = useTranslation();

  if (!message) return null;

  return (
    <Alert
      severity="info"
      role="status"
      variant="standard"
      action={
        <Button variant="default-outlined" onClick={onAdd}>
          {actionLabel ?? t("Add")}
        </Button>
      }
    >
      <AlertTitle>{t("Personal Bank Account")}</AlertTitle>
      {message}
    </Alert>
  );
};

export default BankAccountBanner;
